module.exports = __webpack_public_path__ + "static/media/profilebg.c5e68b8a.png";